// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","agenciesTable":"g8IZzXUzJvYLc8ElWqmH"};